// LD-2515
// Cancel every native HTML5 drag on the central-monitoring routes.
//
// Chrome 153.0.8010.37 on Windows can leave a tab ignoring all mouse and
// keyboard input after a drag start the browser refuses (a press that slips a
// few pixels and is released before the browser processes it). The renderer's
// drag-in-progress flag is never cleared and only a tab close recovers it
// (Chromium bug 522564418, fixed in 153.0.8010.42). Blink only enters that
// state after an uncancelled dragstart, so cancelling dragstart in the capture
// phase keeps the renderer out of it. Pinned-tile and Quick View reordering are
// already disabled on these routes, so no wanted drag is lost. Links, images
// and selected text are the remaining native drag sources this covers.
//
// The warning is deliberate: LogRocket records console output, so each blocked
// drag becomes visible in session replays.

const GUARDED_ROUTES = new Set(['infinity-watch', 'patient-central.team-mode'])

export function initDragGuard(router) {
  document.addEventListener('dragstart', (event) => {
    if (!GUARDED_ROUTES.has(router.currentRoute.value?.name)) return

    event.preventDefault()
    event.stopImmediatePropagation()

    const target = event.target instanceof Element ? event.target : null
    console.warn('[drag-guard] cancelled native drag', {
      route: router.currentRoute.value.name,
      tag: target?.tagName,
      classes: target?.getAttribute('class') || ''
    })
  }, { capture: true })
}
